// Shared react-joyride theme — matches DESIGN.md tokens (ink #09090B
// primary, rounded-sm 6px buttons / rounded-lg 12px cards, Inter font).
export const tourOptions = {
  primaryColor: "#09090B",
  textColor: "#09090B",
  backgroundColor: "#FFFFFF",
  overlayColor: "rgba(9, 9, 11, 0.55)",
  arrowColor: "#FFFFFF",
  zIndex: 10000,
  showProgress: true,
  // v3 default is ['back', 'close', 'primary'] — 'skip' must be added
  // explicitly to show a Skip button.
  buttons: ["back", "skip", "primary"],
  spotlightRadius: 12,
};

export const tourStyles = {
  tooltip: {
    borderRadius: 12,
    fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
  },
  tooltipTitle: {
    fontWeight: 700,
    fontSize: 15,
    letterSpacing: "-0.01em",
    color: "#09090B",
  },
  tooltipContent: {
    fontSize: 13,
    lineHeight: 1.5,
    color: "#3F3F46",
  },
  buttonPrimary: {
    backgroundColor: "#09090B",
    color: "#FAFAFA",
    borderRadius: 6,
    padding: "8px 16px",
    fontSize: 13,
    fontWeight: 600,
  },
  buttonBack: {
    color: "#71717A",
    fontSize: 13,
  },
  buttonSkip: {
    color: "#71717A",
    fontSize: 13,
  },
};
